import axios from 'axios';

const apiUrl = import.meta.env.VITE_PWA_AND_IDENTIFY_API_URL;

if (!apiUrl) throw new Error('VITE_PWA_AND_IDENTIFY_API_URL is not defined');

const instance = axios.create({
	baseURL: apiUrl ?? 'about:blank',
});

export const getFromAPI = (path: string) =>
	instance.get(path).then((res) => res.data);

export const postToAPI = (path: string, data: FormData) =>
	instance.post(path, data).then((res) => res.data);

export default instance;
